export default "<div style=\"position: relative;\">\n    <figure class=\"highcharts-figure\">\n        <div id=\"container\"></div>\n    </figure>\n</div>\n";